<template>
  <!-- <div> -->
    <!-- <v-container fluid> -->
      <!-- <h3>Select Nation</h3> -->
      <v-row class="d-flex align-center">
        <v-col cols="10">
          <v-select
            v-model="select"
            :hint="`${select.Country}, ${select.Code}`"
            :items="items"
            item-text="Country"
            item-value="Code"
            label="Select"
            persistent-hint
            return-object
            single-line
            @input="valueChangedMethodInComponent"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-img :src="select.ImgUrl" max-width="40"></v-img>
        </v-col>
      </v-row>
    <!-- </v-container> -->
  <!-- </div> -->
</template>

<script>
import axios from "axios";

export default {
  name: "ComponentTest",
  //   props: ["myProp"], //Single prop
  props: {
    id: Number,
    text: String, //from view
  },
  data() {
    return {
      compId: this.id,
      compText: this.text,
      //   compValue: String,
      select: [], //{ Country: "Norway", Code: "se" },
      items: [],
      errors: [],
    };
  },
  created() {
    axios
      //.get("http://localhost:3000/dbapi/getflags/w40/0")
      .get("https://pgapi.azurewebsites.net/dbapi/getflags/w40/0")
      .then((response) => {
        // JSON responses are automatically parsed.
        this.items = response.data;
        // this.select = response.data[0];
        let arr = this.items;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].Code == this.text) {
            this.select = arr[i];
          }
        }
        // this.compValue = this.select.text;
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
  methods: {
    valueChangedMethodInComponent() {
      //   this.model = null;
      this.$emit("valueChangedMethodInComponent", this.select.Code);
      //In Parent, se Test.vue: <DynamicComponentTest v-bind:id="post.id" v-bind:text="post.text" @valueChangedMethodInComponent="setValueMethodInView"></DynamicComponentTest>
      //In Parent, se Test.vue - sende helt object <DynamicComponentTest v-bind="post" @valueChangedMethodInComponent="setValueMethodInView"></DynamicComponentTest>
    },
  },
};
</script>

